import { Fragment, type ReactNode } from "react";
import type { ArtworkContentBlock, ArtworkInline } from "@eaf/contracts";

export function ArtworkContent({ blocks }: { blocks: ArtworkContentBlock[] }) {
  return blocks.map((block, blockIndex) => {
    const key = `${block.type}-${blockIndex}`;
    if (block.type === "heading") {
      return block.level === 2 ? <h2 key={key}>{block.text}</h2> : <h3 key={key}>{block.text}</h3>;
    }
    if (block.type === "paragraph") {
      return <p key={key}>{inlineNodes(block.content, key)}</p>;
    }
    if (block.type === "quote") {
      return <blockquote key={key}>{inlineNodes(block.content, key)}</blockquote>;
    }
    const List = block.ordered ? "ol" : "ul";
    return (
      <List key={key}>
        {block.items.map((item, itemIndex) => (
          <li key={`${key}-${itemIndex}`}>{inlineNodes(item, `${key}-${itemIndex}`)}</li>
        ))}
      </List>
    );
  });
}

function inlineNodes(content: ArtworkInline[], keyPrefix: string): ReactNode[] {
  return content.map((item, index) => {
    const key = `${keyPrefix}-${index}`;
    if (item.type === "break") return <br key={key} />;

    let value: ReactNode = item.text;
    for (const mark of item.marks) {
      value = mark === "strong" ? <strong>{value}</strong> : <em>{value}</em>;
    }
    if (item.type === "link") {
      value = <a href={item.href}>{value}</a>;
    }
    return <Fragment key={key}>{value}</Fragment>;
  });
}
